const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const password = /^(?=.*[A-Z])(?=.*[@#$%^&+*!=]).*$/;
const onlyNumber = /^[\d ]*$/;

export const regex = {
  email,
  password,
  onlyNumber
};
